import { useEffect } from 'react';
import Lenis from 'lenis';

// Inertial smooth scrolling for the whole page (Lenis).
// Anchor links (#portfolio etc.) are eased too. Skipped for reduced motion.
export default function useSmoothScroll() {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const lenis = new Lenis({
      lerp: 0.085,
      wheelMultiplier: 0.9,
      anchors: true,
      autoRaf: true
    });
    window.__lenis = lenis;
    return () => {
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);
}
